import React from "react";
import { useTranslation } from 'react-i18next';

import { useFormik } from "formik";
import Input from "../Input";
import Button from "../Button";
import validationRules from "../../../utils/validationRules";

const Form = ({
  fields,
  initValues,
  submitValue,
  submitFunc,
  children,
  agreement = true,
}) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: validationRules(initValues),
    onSubmit: (values) => {
      submitFunc(values);
    },
    enableReinitialize: true,
  });
  const handleChanges = (val) => {
    formik.handleChange(val);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="form_input_list">
        {fields.map((el) => (
          <div className="inp_wrap">
            <Input
              key={el.key}
              type={el.type}
              name={el.name}
              label={t(el.label)}
              placeholder={t(el.placeholder)}
              onChange={handleChanges}
              value={formik.values[el.name]}
              erorr={formik.errors[el.name]}
              touched={formik.touched[el.name]}
              id={el.id}
            />
            {formik.touched[el.name] && formik.errors[el.name] ? (
              <div className="input_error">
                <span>{formik.errors[el.name]}</span>
              </div>
            ) : null}
          </div>
        ))}
      </div>
      {children}
      <Button type="submit" disabled={!agreement}>
        {submitValue}
      </Button>
    </form>
  );
};
export default Form;
